import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckIcon } from '@heroicons/react/24/solid';

const steps = [
  { id: 1, name: 'Type', path: '/type' },
  { id: 2, name: 'Upload', path: '/upload' },
  { id: 3, name: 'Analysis', path: '/analysis' },
  { id: 4, name: 'Book', path: '/book-setup' },
];

export default function StepProgress({ currentStep }) {
  const navigate = useNavigate();

  const handleStepClick = (step) => {
    // Allow navigation to completed steps and current step
    if (step.id <= currentStep) {
      navigate(step.path);
    }
  };

  return (
    <nav aria-label="Progress">
      <ol className="flex items-center justify-center gap-1 sm:gap-4">
        {steps.map((step, index) => {
          const isComplete = step.id < currentStep;
          const isCurrent = step.id === currentStep;
          const isPending = step.id > currentStep;
          const isClickable = step.id <= currentStep;
          
          return (
            <li key={step.id} className="flex items-center">
              {/* Step indicator */}
              <button
                type="button"
                onClick={() => handleStepClick(step)}
                disabled={!isClickable}
                className={`
                  flex flex-col items-center group
                  ${isClickable ? 'cursor-pointer' : 'cursor-not-allowed'}
                `}
                aria-label={`Go to ${step.name} step`}
                aria-current={isCurrent ? 'step' : undefined}
              >
                <div
                  className={`
                    flex items-center justify-center w-7 h-7 sm:w-10 sm:h-10 rounded-full
                    font-display font-bold text-xs sm:text-base transition-all duration-300
                    ${isComplete ? 'bg-forest text-white' : ''}
                    ${isCurrent ? 'bg-rust text-white ring-4 ring-rust/20' : ''}
                    ${isPending ? 'bg-parchment text-sepia/60' : ''}
                    ${isClickable && !isCurrent ? 'hover:ring-4 hover:ring-forest/20 hover:scale-110' : ''}
                  `}
                >
                  {isComplete ? (
                    <CheckIcon className="w-4 h-4 sm:w-5 sm:h-5" />
                  ) : (
                    step.id
                  )}
                </div>
                <span
                  className={`
                    mt-1 text-xs font-medium hidden sm:block transition-colors duration-200
                    ${isCurrent ? 'text-rust' : 'text-sepia/60'}
                    ${isClickable && !isCurrent ? 'group-hover:text-forest' : ''}
                  `}
                >
                  {step.name}
                </span>
              </button>
              
              {/* Connector line */}
              {index < steps.length - 1 && (
                <div
                  className={`
                    w-4 sm:w-12 h-0.5 mx-0.5 sm:mx-2 transition-colors duration-300
                    ${step.id < currentStep ? 'bg-forest' : 'bg-parchment'}
                  `}
                />
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

